// GlamDist Pro — API Service FINAL
const BASE = "https://api.dawntoduskpro.com/api";

export const getToken = () => localStorage.getItem("gd_token");
export const setToken = (t) => localStorage.setItem("gd_token", t);
export const removeToken = () => localStorage.removeItem("gd_token");

async function req(method, path, body) {
  const token = localStorage.getItem("gd_token");
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = "Bearer " + token;
  console.log("[API]", method, path, body ? JSON.stringify(body).substring(0,50) : "");
  const res = await fetch(BASE + path, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  console.log("[API Response]", path, JSON.stringify(data).substring(0,80));
  if (!res.ok) throw new Error(data.error || "Server error");
  return data;
}

const get   = (p)      => req("GET",    p);
const post  = (p, b)   => req("POST",   p, b);
const put   = (p, b)   => req("PUT",    p, b);
const del   = (p)      => req("DELETE", p);
const patch = (p, b)   => req("PATCH",  p, b);

// Company IDs: "C1","C2" = existing, "C"+13digits = new
// Customer/Supplier/Product IDs: small int = existing, 13-digit timestamp = new
const isNewCo  = (id) => !id || id === '';
const isNewInt = (id) => !id || (typeof id === "number" && id > 9999999999) || (typeof id === "string" && /^[A-Z]{2}\d{10,}/.test(id));

export const API = {
  login: async (u, p) => {
    const res = await fetch(BASE + "/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: u, password: p }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Login failed");
    if (data.token) localStorage.setItem("gd_token", data.token);
    return data;
  },

  getCompanies:   ()     => get("/companies"),
  saveCompany:    (d)    => isNewCo(d.id)  ? post("/companies", d)         : put("/companies/"  + d.id, d),
  createCompany:  (d)    => post("/companies", d),
  updateCompany:  (d)    => put("/companies/" + d.id, d),
  deleteCompany:  (id)   => del("/companies/" + id),

  getCustomers:   ()     => get("/customers"),
  saveCustomer:   (d)    => isNewInt(d.id) ? post("/customers", d)         : put("/customers/"  + d.id, d),
  createCustomer: (d)    => post("/customers", d),
  updateCustomer: (d)    => put("/customers/" + d.id, d),
  deleteCustomer: (id)   => del("/customers/"  + id),

  getSuppliers:   ()     => get("/suppliers"),
  saveSupplier:   (d)    => isNewInt(d.id) ? post("/suppliers", d)         : put("/suppliers/"  + d.id, d),
  createSupplier: (d)    => post("/suppliers", d),
  updateSupplier: (d)    => put("/suppliers/" + d.id, d),
  deleteSupplier: (id)   => del("/suppliers/"  + id),

  getProducts:    ()     => get("/products"),
  getProductByBarcode: (code) => get("/products/barcode/" + encodeURIComponent(code)),
  saveProduct:    (d)    => isNewInt(d.id) ? post("/products", d)          : put("/products/"   + d.id, d),
  createProduct:  (d)    => post("/products", d),
  updateProduct:  (d)    => put("/products/" + d.id, d),
  deleteProduct:  (id)   => del("/products/"   + id),
  updateStock:    (id,n) => patch("/products/" + id + "/stock", { change: n }),

  getOrders:      ()     => get("/orders"),
  createOrder:    (d)    => post("/orders", d),
  updateOrder:    (id,d) => put("/orders/"     + id, d),
  updateStatus:   (id,s) => put("/orders/"     + id + "/status", { status: s }),
  deleteOrder:    (id)   => del("/orders/"     + id),

  getPayments:    ()     => get("/payments"),
  createPayment:  (d)    => post("/payments", d),
  deletePayment:  (id)   => del("/payments/"   + id),

  getPurchases:   ()     => get("/purchases"),
  createPurchase: (d)    => post("/purchases", d),
  getBatches:     ()     => get("/batches"),
  updateBatch:    (d)    => put("/batches/" + d.id, d),
  deleteBatch:    (id)   => del("/batches/" + id),
  deletePurchase: (id)   => del("/purchases/"  + id),

  getNotes:       ()     => get("/notes"),
  createNote:     (d)    => post("/notes", d),
  deleteNote:     (id)   => del("/notes/"      + id),

  getUsers:       ()     => get("/users"),
  createUser:     (d)    => post("/users", d),
  toggleUser:     (id)   => put("/users/"      + id + "/toggle"),

  getDashboard:   ()     => get("/dashboard"),
  health:         ()     => get("/health"),
  getTenantInfo:  (id)   => get(`/tenants/${id}/info`),

  // Expenses
  getExpenses:    ()     => get("/expenses"),
  createExpense:  (d)    => post("/expenses", d),
  updateExpense:  (d)    => put("/expenses/" + d.id, d),
  deleteExpense:  (id)   => del("/expenses/" + id),

  // Cheques
  getCheques:     ()     => get("/cheques"),
  createCheque:   (d)    => post("/cheques", d),
  updateCheque:   (d)    => put("/cheques/" + d.id, d),
  deleteCheque:   (id)   => del("/cheques/" + id),

  // Accounts (Cash & Bank)
  getAccounts:       ()    => get("/accounts"),

  // Reminders
  sendReminder: (d) => post("/send-reminder", d),

  // Beats
  getBeats:          ()    => get("/beats"),
  createBeat:        (d)   => post("/beats", d),
  updateBeat:        (d)   => put("/beats/" + d.id, d),
  deleteBeat:        (id)  => del("/beats/" + id),
  getBeatDispatch:   (date) => get("/beat-dispatch" + (date ? "?date="+date : "")),
  setBeatDispatch:   (d)    => post("/beat-dispatch", d),
  deleteBeatDispatch:(id)   => del("/beat-dispatch/" + id),
  createAccount:     (d)   => post("/accounts", d),
  updateAccount:     (d)   => put("/accounts/" + d.id, d),
  deleteAccount:     (id)  => del("/accounts/" + id),
  getAccountLedger:  (id)  => get("/accounts/" + id + "/ledger"),

  // Supplier Payments
  getSupplierPayments:    ()  => get("/supplier-payments"),
  createSupplierPayment:  (d) => post("/supplier-payments", d),
  deleteSupplierPayment:  (id)=> del("/supplier-payments/" + id),
  getBankReconciliations: ()  => get("/bank-reconciliations"),
  saveBankReconciliation: (d) => post("/bank-reconciliations", d),
  deleteBankReconciliation:(id)=> del("/bank-reconciliations/" + id),

  // User management
  deleteUser:        (id)  => del("/users/" + id),
  changeUserPassword:(u,password) => put("/users/" + u.id, {...u, password}),

  // Notifications
  getNotifications:      ()     => get("/notifications"),
  markNotificationRead:  (id)   => put("/notifications/" + id + "/read", {}),
  markAllNotificationsRead: ()  => put("/notifications/read-all", {}),
  getVapidPublicKey:      ()    => get("/push/vapid-public-key"),
  subscribePush:          (sub) => post("/push/subscribe", sub),

  // Direct methods for Super Admin
  get:  (path)       => get(path),
  post: (path, data) => post(path, data),
  put:  (path, data) => put(path, data),
  del:  (path)       => del(path),
};

export default API;
